<template>
  <div class="page">
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="calendar-shell">
            <p class="eyebrow">Events</p>
            <h1>Google Calendar</h1>
            <p class="lead">
              This section now uses a live Google Calendar embed so visitors can view upcoming events directly.
            </p>

            <div class="calendar-frame">
              <iframe
                src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=America%2FChicago&src=en.usa%23holiday%40group.vcalendar.google.com&color=%232F6309&showTitle=0&showNav=1&showDate=1&showPrint=0&showTabs=0&showCalendars=0&showTz=0"
                style="border: 0"
                width="100%"
                height="600"
                frameborder="0"
                scrolling="no"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Events",
  props: {
    msg: String,
  },
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background-image: url("../assets/screen-5.png");
  background-size: cover;
  background-position: center;
  animation: backgroundMove 120s ease-in-out infinite;
}
.calendar-shell {
  background: rgba(7, 17, 31, 0.9);
  border-radius: 18px;
  padding: 32px;
  color: white;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.25);
}
.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.8rem;
  color: #c5d4ff;
  margin-bottom: 8px;
}
h1 {
  font-size: 2rem;
  margin-bottom: 8px;
}
.lead {
  color: #dde7ff;
  margin-bottom: 20px;
}
.calendar-frame {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.12);
}
iframe {
  display: block;
  width: 100%;
  min-height: 600px;
}

@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
